export default {
	id: "wayfarer-horizons",
	pride: 8192,
	slug: "wayfarer-horizons",
	category: ["game", "vrchat"],
	completeness: "partial",
	status: "development",
	experienceable: true,
	titleKey: {
		zh: "挑战之旅：地平线"
	},
	descriptionKey: {
		zh: "VRChat 多人 Roguelike。奇灵力量潜藏手臂，从冒险者协会出发踏上挑战旅途。全自动测试，单核心多前端，玩法链路已打通。"
	},
	date: { year: 2026, month: 6 },
	genres: ["Roguelike", "多人", "VRChat"],
	themes: ["奇灵", "冒险"],
	engine: "Unity (VRChat)",
	platform: ["PCVR", "Quest"],
	tags: ["VRChat", "Roguelike"],
	links: [
		{ type: "vrchat", url: "https://vrchat.com/home/world/wrld_83716f50-37d6-4c08-b9d9-00def3a33601/info", textKey: { zh: "VRChat 访问" } }
	]
};
